import { privateClient } from "./client";

const requestRevalidate = data => privateClient.put("/sessions/revalidate", JSON.stringify(data));

const requestResendToken = data => privateClient.post("/sessions/revalidate", JSON.stringify(data));

export { requestRevalidate, requestResendToken };
